import { CrossIcon } from '../../icons/cross-icon';

interface SucceedStateProps {
  setIsCheckingSucceed: (value: boolean) => void;
}

export const SucceedState = ({ setIsCheckingSucceed }: SucceedStateProps) => {
  return (
    <div className='flex flex-col relative w-full rounded-lg border border-gray-200 dark:border-gray-700 shadow py-5 px-6 gap-2 bg-white dark:bg-zinc-800'>
      <div
        className='absolute top-2 right-2 cursor-pointer'
        onClick={() => setIsCheckingSucceed(false)}
      >
        <CrossIcon
          size={24}
          className='stroke-zinc-800 dark:stroke-zinc-200 hover:stroke-zinc-950 dark:hover:stroke-zinc-50 transition'
        />
      </div>
      <p className='font-semibold text-zinc-900 dark:text-zinc-100'>
        Your prompt did not hit any guardrails
      </p>
      <p className='text-zinc-700 dark:text-zinc-300 text-xs'>
        There are no guardrails to prevent a user from creating content with a
        prompt like this.
      </p>
    </div>
  );
};
